import { render, staticRenderFns } from "./InputAvatar.vue?vue&type=template&id=ddb3aaf8&scoped=true"
import script from "./InputAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAvatar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputAvatar.vue?vue&type=style&index=0&id=ddb3aaf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb3aaf8",
  null
  
)

export default component.exports